import { Currency } from "@vierkant-software/types__api";

export const CurrencyFactor: { [key in Currency]?: number } = {
    [Currency.CHF]: 100,
    [Currency.EUR]: 100,
    [Currency.eur]: 100,
};

export function getFractions(currency: Currency): number {
    return CurrencyFactor[currency] ? Math.log10(CurrencyFactor[currency]!) | 0 : 2;
}